import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [submit, setSubmit] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    console.log("------------------------------------------------------------------")
    useEffect(() => {
        const pathname = location.pathname.startsWith('/');
        if (pathname) {
            console.log("Adding classes to the body.");
            document.body.classList.add("bgyellow");
        }
    }, []);
    const handleForgotPassword = (e) => {
        e.preventDefault();

        if (!email.trim()) {
            toast.error("Email is required");
            return;
        }
        // Email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            toast.error("Invalid email format");
            return;
        }

        // API Call
        axios
            .post(`${process.env.REACT_APP_APIURL}business/password/forgot`, {
                email_address: email,
            })
            .then((res) => {
                if (res.data.status === "success") {
                    setSubmit(true);
                    toast.success("Check your email for password reset link.");
                    setTimeout(() => {
                        setSubmit(false);
                    }, 3000);
                }
                else if (res.data.status_code == 409) {
                    toast.error(res.data.message);
                    setSubmit(false);
                } else if (res.data.status_code == 204 || res.data.status == 'no_record') {
                    toast.error("Email not found. Please check or sign up")
                    setSubmit(false);
                }
                else {
                    if (res.data.error && res.data.error.message) {
                        toast.error(res.data.error.message);
                    } else {
                        toast.error("An error occurred during password reset");
                    }
                    setSubmit(false);
                }
            })
            .catch((err) => {
                setSubmit(true);
                // console.error("Password reset error:", err.response.data.error.message);
                toast.error("Reset password link already sent to your email.");
                setSubmit(false);
            });
    };

    return (
            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
                        <div
                            className="card shadow-sm border-0"
                            style={{
                                borderRadius: '16px',
                                padding: '2rem',
                                backgroundColor: '#ffffff'
                            }}
                        >
                            {/* Header */}
                            <div className="text-center mb-4">
                                <div
                                    className="d-inline-flex align-items-center justify-content-center mb-3"
                                    style={{
                                        width: '64px',
                                        height: '64px',
                                        backgroundColor: '#FFC107',
                                        borderRadius: '16px'
                                    }}
                                >
                                    <i className="fas fa-key" style={{ fontSize: '24px', color: 'white' }}></i>
                                </div>
                                <h2 className="mb-2" style={{ fontSize: '1.75rem', fontWeight: '600', color: '#1a1a1a' }}>
                                    Reset Your Password
                                </h2>
                                <p className="text-muted mb-0" style={{ fontSize: '0.95rem', lineHeight: '1.5' }}>
                                    Don't worry! Enter your email address and we'll send you a link to reset your password.
                                </p>
                            </div>

                            {/* Form */}
                            <form onSubmit={handleForgotPassword}>
                                <div className="mb-4">
                                    <input
                                        id="email"
                                        type="email"
                                        className="form-control"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="Enter your email address"
                                        style={{
                                            height: '52px',
                                            fontSize: '16px',
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '12px',
                                            padding: '0 16px',
                                            backgroundColor: '#fafafa'
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = '#FFC107';
                                            e.target.style.backgroundColor = '#ffffff';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = '#e0e0e0';
                                            e.target.style.backgroundColor = '#fafafa';
                                        }}
                                    />
                                    <label
                                        htmlFor="email"
                                        className="form-label mt-2 mb-0"
                                        style={{ fontSize: '0.875rem', fontWeight: '500', color: '#666' }}
                                    >
                                        Email Address
                                    </label>
                                </div>

                                <div className="mb-4">
                                    {submit ? (
                                        <button
                                            type="submit"
                                            className="btn w-100 d-flex align-items-center justify-content-center"
                                            disabled
                                            style={{
                                                height: '52px',
                                                fontSize: '16px',
                                                fontWeight: '500',
                                                borderRadius: '12px',
                                                backgroundColor: '#cccccc',
                                                border: 'none',
                                                color: 'white'
                                            }}
                                        >
                                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                            Sending...
                                        </button>
                                    ) : (
                                        <button
                                            type="submit"
                                            className="btn w-100"
                                            style={{
                                                height: '52px',
                                                fontSize: '16px',
                                                fontWeight: '500',
                                                borderRadius: '12px',
                                                backgroundColor: '#FFC107',
                                                border: 'none',
                                                color: 'white',
                                                transition: 'all 0.2s ease'
                                            }}
                                            onMouseOver={(e) => e.target.style.backgroundColor = '#FFB300'}
                                            onMouseOut={(e) => e.target.style.backgroundColor = '#FFC107'}
                                        >
                                            Send Reset Link
                                        </button>
                                    )}
                                </div>
                            </form>

                            {/* Footer */}
                            <div className="text-center">
                                <p className="mb-0" style={{ fontSize: '0.9rem', color: '#666' }}>
                                    Remember your password?{" "}
                                    <a
                                        href="/login"
                                        style={{
                                            color: '#FFC107',
                                            textDecoration: 'none',
                                            fontWeight: '500'
                                        }}
                                        onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                                        onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                                    >
                                        Back to Login
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
}

export default ForgotPassword;
